const channels = {
  Affiliate: {
    placementIds: [
      510515827, 538296711, 783582278, 783582278, 889722236, 1266686662,
      1369763929, 1416979595, 1424030198, 1814975670, 1847502766, 1848602528,
      1956024651, 2814498753, 4344476667
    ]
  },
  B2B: {
    placementIds: [2109975767]
  },
  Display: {
    placementIds: [
      1695137292, 2817424137, 2892218469, 2892274312, 2892599405, 3022860198,
      3060306542, 3060439488, 3533545312, 3533612830, 3728259809, 3801770748,
      4076748799, 4241679636, 5622405860
    ]
  },
  'Facebook Ads': {
    placementIds: [1846069601]
  },
  'Google GDN': {
    placementIds: [1835743578]
  },
  'Internes email-Marketing': {
    placementIds: [
      996806342, 1282523492, 1384312741, 1384507039, 1387932638, 1407057820,
      1407072126, 1424635046, 1495253707, 1499384856, 1535663783, 1538818137,
      1697865240, 1818411005, 2081966029, 2081969928, 2124242145, 2136134866,
      2136137958, 3036565852, 3128517217, 4638897688, 4686888596, 4704137435,
      4704146354, 4704177147, 4704187432, 5501061952, 5572663985, 5572731739
    ]
  },
  'Partner Email': {
    placementIds: [936192501, 1386120531, 1466641945]
  },
  Remarketing: {
    placementIds: [785716052, 2524323644]
  },
  ScoreKompass: {
    placementIds: [
      1024994474, 1213100454, 1419717527, 2558217947, 2669445519, 2669461678
    ]
  },
  SEM: {
    placementIds: [
      1006998846, 1007014272, 1007023174, 1007137928, 1007217854, 1007617942,
      1007938812, 1007983234, 1007987484, 1008757042, 1008812164, 1008825012,
      1009173187, 1009175111, 1009210937, 1009242561, 1009246640, 1009793114,
      1009797374, 1009818419, 1009824826, 1009847673, 1010641787, 1010684379,
      1012125027, 1012125876, 1018563922, 1024765666, 1036183204, 1038356260,
      1039621036, 1059126026, 1070998540, 1072295413, 1087675314, 1091700596,
      1099140365, 1111919882, 1116336829, 1121768883, 1156420689, 1165779859,
      1178445526, 1178447109, 1178447611, 1178448479, 1178451382, 1178452424,
      1178454062, 1178454744, 1178455095, 1178456066, 1178456413, 1178456870,
      1178457747, 1178460593, 1178651778, 1188312566, 1194817945, 1212321694,
      1212878401, 1212880000, 1212886748, 1212909256, 1212914022, 1212919909,
      1212920434, 1272416304, 1300103762, 1300136916, 1301586687, 1301621851,
      1301821242, 1467729212, 1544428849, 1544756048, 1544768075, 1544770724
    ]
  },
  'SEM Brand': {
    placementIds: [1078433476, 1078599059]
  },
  SEO: {
    placementIds: [
      1265653843, 1272934750, 1273016855, 1273017617, 1273018433, 1273018807,
      1273019672, 1273020068, 1273020503, 1338961768, 5761199269
    ]
  },
  'SEO Brand': {
    placementIds: [61575100]
  },
  'smava intern': {
    placementIds: [201077]
  },
  'smava intern direct': {
    placementIds: [1016929399]
  }
}

export const getChannelByPlacementId = (placementId: string) => {
  if (!placementId) {
    return null
  }

  const isChannelFound = Object.keys(channels).find((key) => {
    if (
      channels[key].placementIds.find(
        (placement: number) => `${placement}` === placementId
      )
    ) {
      return key
    }
    return null
  })

  return isChannelFound || null
}
